<div class="policy-disclaimer-bg" style="overflow: hidden auto;height: var(--vh, 1vh) ;">
    <div class="row m-0 mobile-hide">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-3 col-sm-12 p-0">
            <img class="mob-outlive-logo" [src]="commonService.resource.image.outlive_chat" alt="">
        </div>
        <div class="col-md-7 p-0"></div>
    </div>
    <div class="pt-5">
        <div class="policy-disclaimer-bg-image align-items-center mobile-show justify-content-center d-flex">
            <img class="position-absolute" style="width: 76px;" [src]="commonService.resource.image.privacy_disclaimer_img" alt="">
            <img class="w-100 mobile-hide" [src]="commonService.resource.image.policy_disclaimer_bg_desk" alt="">
            <img class=" mobile-show w-100" [src]="commonService.resource.image.privacy_disclaimer_bg" alt="">
        </div>
    </div>
    <div class="content-container landing-page-container overflow-auto" style="height: calc(var(--vh, 1vh)  - 180px);">
        <div class="row m-0 h-100">
            <div class="col-md-2 p-0"></div>
            <div class="col-md-3 col-sm-12 p-0 mt-5">
                <div class="d-flex justify-content-between flex-column policy-home-overflow" style="overflow: hidden auto;">
                    <div class="mt-5">
                        <div class="app-sub-content font-14 d-block" style="text-align: justify" [innerHTML]="('policyDisclaimer.content' | translate)"></div>
                        <div class="mt-5 policy-sub-heading">
                            <div class="d-flex justify-content-between align-items-center pb-2" (click)="navigateToContent(true)">
                                <div class="">
                                    Privacy Policy
                                </div>
                                <div class="">
                                    <span class="material-icons-two-tone">
                                        chevron_right
                                        </span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between  align-items-center pb-2" (click)="navigateToContent(false)">
                                <div class="">Terms of Service</div>
                                <div class="">
                                    <span class="material-icons-two-tone">
                                        chevron_right
                                        </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 p-0 position-relative mobile-hide"></div>
            <div class="col-md-2 p-0 mobile-hide"></div>
        </div>
    </div>
    <div class="row m-0">
        <div class="col-md-2 p-0"></div>
        <div class="col-md-4 col-sm-12 p-0">
            <div class="policy-btn-container">
                <div class="policy-btn-content" [innerHTML]="('policyDisclaimer.btnSubContent' | translate)"></div>
                <button mat-button class="primary-button policy-btn w-100 mt-4" (click)="acceptPrivacyPolicy()"> {{'policyDisclaimer.policyBtn' | translate}}</button>
            </div>
        </div>
        <div class="col-md-4 mobile-hide p-0"></div>
        <div class="col-md-2 mobile-hide p-0"></div>
    </div>
</div>